import { render, staticRenderFns } from "./EditAdvanced.vue?vue&type=template&id=faa164c2&scoped=true&"
import script from "./EditAdvanced.vue?vue&type=script&lang=js&"
export * from "./EditAdvanced.vue?vue&type=script&lang=js&"
import style0 from "./EditAdvanced.vue?vue&type=style&index=0&id=faa164c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa164c2",
  null
  
)

export default component.exports